/* contains marketplace app specific constants */
export const defaultApp = {
  id: '',
  name: '',
  description: '',
  createdAt: '',
  createdBy: {
    id: '',
    firstName: '',
    lastName: '',
  },
  supportEmail: '',
  isInstalled: false,
  currentVersion: '',
  screenshots: [],
  avatar: '',
  objectUrl: '',
  releaseNotes: '',
}

export const createAppRule = {
  name: {
    message: 'App name is missing',
    type: "string",
  },
  description: {
    type: "string",
    message: 'App description is missing',
    min: {
      limit: 50,
      message: 'App description should contain atleast 50 characters',
    },
    max: {
      limit: 500,
      message: 'App description should not exceed 500 characters',
    },
  },
  objectUrl: {
    type: "string",
    message: 'Please upload the app artifact',
  },
  currentVersion: {
    type: "string",
    message: 'App version is missing',
  },
}

export const createReleaseRule = {
  releaseNotes: {
    message: 'Please provide release notes',
    type: "string",
  },
  objectUrl: {
    type: "string",
    message: 'Please upload the app artifact',
  },
  versionTag: {
    type: "string",
    message: 'App version is missing',
  },
}

export const supportedFileTypes = ["application/zip", "application/x-zip-compressed"];
export const supportedImageTypes = ["image/png", "image/jpg", "image/jpeg"];
